import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, HostBinding, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { GridCell, RowCell, HeroLayoutEnum, Section, VerticalAlignEnum, ContentElement, ContentElementEnum, SectionData } from '../../models/sections-model';
import { GridRendererComponent } from '../grid-renderer/grid-renderer.component';


@Component({
  selector: 'kw-hero-image-renderer',
  templateUrl: './hero-image-renderer.component.html',
  styleUrls: ['./hero-image-renderer.component.scss']
})
export class HeroImageRendererComponent extends GridRendererComponent implements OnInit,OnDestroy,OnChanges,AfterViewInit {
  @Input() data:SectionData;
  @Input() edit:boolean;
  @Input() heading:string;
  title:ContentElement;
  @HostBinding("style.--content-layout-width") contentWidth:string;
  @HostBinding("style.--hero-max-height") heroMaxHeight:string;
  selectedCell: GridCell | RowCell;
 
  bgClass:string = "image";
  bgImgSrc:string;

  //blurry gradient
  //BG rect + 6 circles
  blurryRectColor:string = "var(--color-primary-700)";
  blurryCircle1:string ="var(--color-primary-100)";
  blurryCircle2:string = "var(--color-primary-100)";
  blurryCircle3:string = "var(--color-primary-100)";
  blurryCircle4:string = "var(--color-primary-700)";
  blurryCircle5:string = "var(--color-primary-700)";
  blurryCircle6:string = "var(--color-primary-700)";

  //stacked-waves
  
  stackedWaves1:string ="var(--color-primary-700)";
  stackedWaves2:string ="var(--color-primary-700)";
  stackedWaves3:string ="var(--color-primary-600)";
  stackedWaves4:string ="var(--color-primary-500)";
  stackedWaves5:string ="var(--color-primary-400)";

  layeredWavesBg:string = "var(--color-primary-500)"
  layeredWavesColor1:string = "var(--color-primary-200)"
  layeredWavesColor2:string = "var(--color-primary-400)"

    
  //layered-peaks
  //BG rect + 5 path colors
  rectColor:string = "var(--color-primary-700)";
  rectPath1Color1:string = "var(--color-primary-600)";
  rectPath1Color2:string = "var(--color-primary-500)";
  rectPath1Color3:string = "var(--color-primary-400)";
  rectPath1Color4:string = "var(--color-primary-500)";
  rectPath1Color5:string = "var(--color-primary-600)";

  //stacked-peaks
  stackedPeaks1:string = "var(--color-primary-700)";
  stackedPeaks2:string ="var(--color-primary-700)";
  stackedPeaks3:string = "var(--color-primary-600)";
  stackedPeaks4:string = "var(--color-primary-500)";
  stackedPeaks5:string = "var(--color-primary-400)";

  //stacked-steps
  stackedSteps1:string = "var(--color-primary-700)";
  stackedSteps2:string ="var(--color-primary-700)";
  stackedSteps3:string = "var(--color-primary-700)";
  stackedSteps4:string = "var(--color-primary-600)";
  stackedSteps5:string = "var(--color-primary-500)";
  stackedSteps6:string = "var(--color-primary-400)";

  stackedStepsColor1:string = "var(--color-primary-300)";//light
  stackedStepsColor2:string = "var(--color-primary-700)";//dark

  //heroContainerElement:HTMLElement;
  rendererEl:ElementRef<HTMLElement>;
  svgElement:HTMLElement;
  layoutEl:HTMLElement;
  wrapperClass = "transparent";

  @ViewChild('heroContainer',{read:ElementRef}) heroContainer:ElementRef<HTMLElement>
  contentAlign:string;//Horizontal
  //contentWidth:string;
  verticalAlign:string;//Vertical
  height_n:number; //Number height for svg element;

  @Output() editUpdate = new EventEmitter<any>();
  @Output() createUpdate = new EventEmitter<GridCell>();

  constructor(el:ElementRef<any>,cdr:ChangeDetectorRef) {
    super(el,cdr)
    console.log(el);
    this.rendererEl = el;
    //this.layoutEl = el.nativeElement.closest("NB-DIALOG-CONTAINER")?el.nativeElement.closest("NB-DIALOG-CONTAINER"):el.nativeElement.closest("NB-LAYOUT-COLUMN");
    /* this.selectorPosChange$ = this.cellEditorStoreService.selectorPosChange$.subscribe(thing => {
      this.reposPreviewElements(this.previewElements)
    }) */
   }
  ngOnDestroy(): void {
    //this.observer.unobserve(this.layoutEl);
  }

  ngOnInit(): void {
    super.ngOnInit();
    console.log(this.data);
    this.title = this.data.title;
    this.layoutClass = this.resolveLayoutClass(this.data.layoutClass)
    this.bgImgSrc = "url("+this.data["imgSrc"]+")";
    this.selectedCell = this.data.gridOptions.gridCells[0];
    this.setDefaultContainerClasses(this.selectedCell);
    
/*     if(this.layoutClass == "HeroLayoutEnum.GRID_4_2_3"){
      this.layoutClass="cell-4-2-3";
    } */
    /* let windowHeight = window.innerHeight - 120;
    this.heroMaxHeight = windowHeight+"px";
    console.log(this.heroMaxHeight) */

  }

  ngAfterViewInit():void{
    //super.ngAfterViewInit();
    this.verticalAlign = this.data.verticalAlign?this.data.verticalAlign:VerticalAlignEnum.MIDDLE;
    this.svgElement = this.heroContainer.nativeElement.querySelector('.svg');
    console.log({svgElement:this.svgElement});
    this.layoutEl = this.rendererEl.nativeElement.closest("NB-DIALOG-CONTAINER")?this.rendererEl.nativeElement.closest("NB-DIALOG-CONTAINER"):this.rendererEl.nativeElement.closest("NB-LAYOUT-COLUMN");
    console.log({layoutEl:this.layoutEl});
    //this.layoutEl = this.heroContainer.nativeElement.closest("NB-DIALOG-CONTAINER")?this.heroContainer.nativeElement.closest("NB-DIALOG-CONTAINER"):this.heroContainer.nativeElement.closest("NB-LAYOUT-COLUMN");
    /* if(this.layoutEl != undefined){
      
      let styles = getComputedStyle(this.layoutEl);
      console.log({paddingLeft:parseFloat(styles.paddingLeft)});
      console.log({paddingRight:parseFloat(styles.paddingRight)});

      const width = this.layoutEl.offsetWidth+parseFloat(styles.paddingLeft)+parseFloat(styles.paddingRight);
      
      console.log({width:width});
      this.height_n = width/16*9;
      this.svgElement.style.width = width+"px";
      this.svgElement.style.height = this.height_n+"px";
      this.heroContainer.nativeElement.style.width = width+"px";
      this.heroContainer.nativeElement.style.height = this.height_n+"px";

     
      let contentEl = <HTMLElement>this.heroContainer.nativeElement.querySelector('.content-layout');
      let postioningEl = <HTMLElement>this.heroContainer.nativeElement.querySelector('.vertical-position');
      let currentPosition = contentEl.offsetTop;
      console.log(currentPosition)
      if(this.verticalAlign != undefined && this.verticalAlign != "none"){
        
        if(contentEl != undefined){
          this.transformPosition(contentEl,postioningEl,this.verticalAlign);
        }     
      }else{
        console.log("Not doing a transform");
      }
    }else{
      console.log("Can't find it")
    } */
    

    
    
  }

  ngOnChanges(changes:SimpleChanges):void{
    if(changes["selectedCell"]){
      console.log(this.selectedCell);
    }
  }

  resizeSvg(widthEl:HTMLElement,heightEl:HTMLElement){
    const width = widthEl.getBoundingClientRect().width;
    const height = heightEl.getBoundingClientRect().height;
    console.log({width:width,height:height});
    console.log(this.svgElement);
    /* this.svgElement.style.width = width+"px";
    this.svgElement.style.height = width/16*9+"px";
    this.heroContainer.nativeElement.style.width = width+"px";
    this.heroContainer.nativeElement.style.height = width/16*9+"px"; */
  }
  /**
   * 
   * @param contentEl Element to be repositioned
   * @param postioningEl Parent element of element to be repositions
   * @param verticalAlign Whether top bottom or middle
   */
  transformPosition(contentEl:HTMLElement,postioningEl:HTMLElement,verticalAlign:string){
    //container-content-top  | container-content-middle | container-content-bottom
    //let currentPosition = contentEl.offsetTop;
    //console.log(currentPosition)
    console.log("doing a transform")
    if(postioningEl.classList.contains("middle")){
      let transformHeight = contentEl.offsetHeight/2;
      console.log(transformHeight);
      contentEl.style.transform = "translateY(-"+transformHeight+"px)";
    }
    
    //
  }

  resolveLayoutClass(layoutEnum:any){
    let enumValue:string;
    if((layoutEnum).includes(".")){
      let enumKey = layoutEnum.split('.')[1] as keyof typeof HeroLayoutEnum;
      enumValue = HeroLayoutEnum[enumKey];
    }else if(HeroLayoutEnum[layoutEnum] != undefined){
      enumValue = HeroLayoutEnum[layoutEnum]
    }else{
      enumValue = layoutEnum;
    }
    console.log(enumValue)
    return enumValue;
  }

  setDefaultContainerClasses(gridCell:GridCell):void{
    gridCell.contentElements.forEach(cntEl => {
      if(!cntEl.containerClasses){
        cntEl.containerClasses = [];
      }
      switch (this.getEnumValue(cntEl)) {
        case "heading":
          cntEl["containerClasses"].push("heading-container");
          break;
        case "sub-header":
          cntEl["containerClasses"].push("sub-header-container")
          break;
        case "text":
          cntEl["containerClasses"].push("text-container")
          break;
        case "action":
          cntEl["containerClasses"].push("action-container")
          break;
        case "byline":
          cntEl["containerClasses"].push("byline-container")
          break;
        default:
          break;
      }
      console.log(cntEl) 
    })
  }

  getEnumValue(contentElement:ContentElement){
    let enumValue:string;
    let titleEnum = contentElement.contentElementEnum
    if(titleEnum != undefined){
      if((titleEnum).includes(".")){
        let enumKey = titleEnum.split('.')[1] as keyof typeof ContentElementEnum;
        enumValue = ContentElementEnum[enumKey];
      }else if(ContentElementEnum[titleEnum] != undefined){
        enumValue = ContentElementEnum[titleEnum]
      }else{
        enumValue = titleEnum;
      }
    }
    //if(enumValue) enumValue = <string>enumValue.toUpperCase();
    console.log()
    return enumValue;
    /* console.log(titleEnum)
    let title;
    if((titleEnum).includes(".")){
      let enumKey = titleEnum.split('.')[1] as keyof typeof ContentElementEnum;
      title = ContentElementEnum[enumKey];
    }else if(ContentElementEnum[titleEnum] != undefined){
      title = ContentElementEnum[titleEnum]
    }else{
      title = titleEnum;
    }
    console.log(title)
    return title */
  }

  createContent(cell:GridCell|RowCell){
    console.log(cell)
    this.createUpdate.emit(cell);
  }

  updateSection(section:Section){
    this.data = section.sectionData;
    this.selectedCell = section.sectionData.gridOptions.gridCells[0];
    let imgSrc = section.sectionData.imgSrc;
    this.bgImgSrc = "url("+imgSrc+")";
    console.log(this.selectedCell,this.bgImgSrc,this.edit);
    //cdr.detectChanges();
  }

  




}
